export const MAX_IDLE_STOP_AFTER_HOURS = 8760;
